module.exports = __webpack_public_path__ + "img/honnor2.ef4fde07.png";